//These are the various card numbers that will result in certain status's
//More information: https://stripe.com/docs/terminal/testing
export const stripeCardNumbers = {
  CARD_APPROVED: '4242424242424242',
  CARD_DECLINED: '4000000000000002',
  CARD_PROCESSING_ERROR: '4000000000000119',
};
